export const getFilteredEvents = (events, selectedCategoryIds, selectedFriendIds, selectedTagIds, selectedTripIds, selectedStartDate, selectedEndDate) => {
    const filteredEvents = {};
    if(events){
        for(let event of Object.values(events)){
            if(selectedCategoryIds.length > 0 && !selectedCategoryIds.includes(event.categoryId))
                continue;
            if(selectedStartDate && selectedEndDate){
                const startDate = event.startDate instanceof Date ? event.startDate : event.startDate.toDate();
                const endDate = event.endDate ? (event.endDate instanceof Date ? event.endDate : event.endDate.toDate()) : startDate;
                const startDateIsBetweenSelectedRange = selectedStartDate <= startDate && selectedEndDate >= startDate;
                const endDateIsBetweenSelectedRange = selectedStartDate <= endDate && selectedEndDate >= endDate;
                const selectedRangeIsBetweenEventRange = startDate <= selectedStartDate && endDate >= selectedEndDate;
                if(!(startDateIsBetweenSelectedRange || endDateIsBetweenSelectedRange || selectedRangeIsBetweenEventRange))
                    continue;
            }
            if(selectedFriendIds.length > 0 && event.friendIds.filter(id=>selectedFriendIds.includes(id)).length == 0)
                continue;
            if(selectedTagIds.length > 0 && event.tagIds.filter(id=>selectedTagIds.includes(id)).length == 0)
                continue;
            if(selectedTripIds.length > 0 && event.tripIds.filter(id=>selectedTripIds.includes(id)).length == 0)
                continue;
            filteredEvents[event.id] = event;
        }
    }
    return filteredEvents;
}